type BlogPostListFilters = {
  searchable?: boolean;
  limit?: number;
  tags?: string[];
  type?: string;
};

export function useBlogPostList(
  filters?: BlogPostListFilters,
  options?: { lazy: boolean },
) {
  return useFetch("/api/blog/posts", {
    query: filters,
    default: () => [],
    lazy: options?.lazy ?? true,
  });
}
